import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError as observableThrowError, forkJoin } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';
import { Constants } from '../core/constants';
import { UserService } from './user.service';
import { PendingTransactionListComponent } from '../payout/pending.transaction.list.component';

@Injectable()
export class JournalEntryService {
  private baseApiUrl: string;
  pendingTransactions: Array<any>;

  private _transactionData: any;
  get TransactionData(): any { return this._transactionData; }

  constructor(private configurationService: ConfigurationService,
    private dialog: MatDialog,
    private constants: Constants, private userService: UserService,
    private httpClient: HttpClient, private router: Router) {
    this.baseApiUrl = this.configurationService.BaseApiUrl;
  }

  getPendingTransactionsOfCustomer(customerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +
      `journal/pending/customer/${customerId}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getPendingTransactionsForAccount(accountId: number, generalLedgerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +
      `journal/pending/${accountId}?generalLedgerId=${generalLedgerId}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getCashierTransaction(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +
      `journal/cashier`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getEntriesByGeneralLedger(generalLedgerId: number, fromDate: Date, toDate: Date, byValueDate: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +
      `journal/generalledger/${generalLedgerId}?fromDate=${fromDate}&&toDate=${toDate}&&byValueDate=${byValueDate}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  getEntriesByGeneralLedgerbranch(generalLedgerId: number, fromDate: Date, toDate: Date, byValueDate: boolean = false,branchId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +
      `journal/generalledger/${generalLedgerId}?fromDate=${fromDate}&&toDate=${toDate}&&byValueDate=${byValueDate}&&branchId=${branchId}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getEntriesByAccount(accountId: number, glId: number, fromDate: Date, toDate: Date, byValueDate: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +
      `journal/account/${accountId}?generalLedgerId=${glId}&&fromDate=${fromDate}&&toDate=${toDate}&&byValueDate=${byValueDate}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
   createIBTEntries(transactionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'journal/createibt', transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  showEntries(title: string, transactionData: any) {
    this._transactionData = transactionData;
    this._transactionData.description = title;
    this.router.navigate(['/transaction/detail']);
  }

  createEntries(transactionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'journal/create', transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createCashEntries(transactionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'journal/cash', transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getEntries(id: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `journal/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authoriseEntries(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'journal/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  deleteEntries(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `journal/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  validateReferenceNoDetails(referenceNoData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'journal/referenceNo', referenceNoData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateTellerStatus(journalTransactionId: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'journal/updatestatus', journalTransactionId).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateEntries(journalEntries: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'journal', journalEntries).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getAccountOrGeneralLedgerSummary(row: any): string {
    if (row.isAccount === true) {
      return `${row.accountNo} / ${row.generalLedgerCode} - ${row.generalLedgerDescription}`;
    } else {
      return row.generalLedgerCode;
    }
  }

  getAccountOrGeneralLedgerDetails(row: any): string {
    if (row.isAccount === true) {
      return `${row.customerName} ${row.customerIdentifier} `;
    } else {
      return row.generalLedgerDescription;
    }
  }

  getCashierListStatus(status): string {
    switch (status) {
      case this.constants.TellerStatus.NewAccount:
        return this.constants.TellerStatusNames.NewAccount;
      case this.constants.TellerStatus.Payable:
        return this.constants.TellerStatusNames.Payable;
      case this.constants.TellerStatus.ToPay:
        return this.constants.TellerStatusNames.ToPay;
      case this.constants.TellerStatus.Paid:
        return this.constants.TellerStatusNames.Paid;
      case this.constants.TellerStatus.ToReceive:
        return this.constants.TellerStatusNames.ToReceive;
      case this.constants.TellerStatus.Received:
        return this.constants.TellerStatusNames.Received;
      case this.constants.TellerStatus.Approved:
        return this.constants.TellerStatusNames.Approved;
      case this.constants.TellerStatus.Deleted:
        return this.constants.TellerStatusNames.Deleted;
      case this.constants.TellerStatus.OpeningCash:
        return this.constants.TellerStatusNames.OpeningCash;
      case this.constants.TellerStatus.ClosingCash:
        return this.constants.TellerStatusNames.ClosingCash;
      case this.constants.TellerStatus.TransferedFrom:
        return this.constants.TellerStatusNames.TransferedFrom;
      case this.constants.TellerStatus.TransferedTo:
        return this.constants.TellerStatusNames.TransferedTo;
    }
  }

  getPendingTransactions(accountId: number, generalLedgerId: number, accountNo: string) {
    this.getPendingTransactionsForAccount(accountId, generalLedgerId)
      .subscribe(result => {
        console.log('pending txn ', result);
        this.pendingTransactions = result.result;
        this.onPendingTransactions(accountNo);
      });
  }

  onPendingTransactions(accountNo: string) {
    this.dialog.open(PendingTransactionListComponent, {
      width: '90%',
      maxHeight: '70vh',
      data: {
        title: `Pending Transactions of - ${accountNo}`,
        rows: this.pendingTransactions
      }
    });
  }

  createTurstTransactionEntries(transactionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'trusttransaction/fundTransfer', transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  
  
  getBalanceEnquiry(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'trusttransaction/balanceenquiry').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getAccountStatement(fromDate: Date, toDate: Date): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 
  `trusttransaction/accountstatement?fromDate=${fromDate}&&toDate=${toDate}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

 
  getById(journalTransactionId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `journal/cash/receipt/${journalTransactionId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getTransferData(journalTransactionId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `journal/transfer/receipt/${journalTransactionId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getGlToGlTransferData(journalTransactionId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `journal/generalledger/receipt/${journalTransactionId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getTransactionsdeletion(applicationModule: number, toDate: Date): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +
      `journal/deletetransaction?applicationModule=${applicationModule}&toDate=${toDate}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
}
